import { defineComponent, computed } from "vue";
import ImageElement from "./component-library8.mjs";
import SingleItemConfigurator from "./component-library184.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "extended-item-info",
  props: {
    isExtended: Boolean,
    bundleItem: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["select-variant"],
  setup(__props) {
    const props = __props;
    const dynamicClass = computed(() => {
      return { "extended-item-info--extended": props.isExtended };
    });
    const image = computed(() => {
      var _a, _b;
      let selectedImg;
      Object.values(props.bundleItem.variants).find((variant) => {
        var _a2;
        const entry = (_a2 = variant == null ? void 0 : variant.items) == null ? void 0 : _a2.find((item) => item.active && item.teaserImage);
        if (entry) {
          selectedImg = entry.teaserImage;
        }
        return entry;
      });
      return selectedImg || ((_b = (_a = props.bundleItem) == null ? void 0 : _a.images) == null ? void 0 : _b[0]);
    });
    return { __sfc: true, props, dynamicClass, image, ImageElement, SingleItemConfigurator };
  }
});
export {
  _sfc_main as default
};
